module.exports = __webpack_public_path__ + "static/media/boomreader_reversed.8b56ac35.png";